import Grid from "@material-ui/core/Grid";
import React from "react";

const PlayInitialStep = ({ additionalActions }) => {
	return (
		<Grid container spacing={1} justifyContent="center">
			<Grid item xs={12}>
				<Grid container>{additionalActions}</Grid>
			</Grid>
		</Grid>
	);
};

export default PlayInitialStep;
